export interface AccountState {
    societeIds: number[];
}

export const state: AccountState = {
    societeIds: [],
};

export interface ProfilDTO {
    nom: string;
    prenom: string;
    adresseMail: string;
    identifiant: string;
    telephoneFixe: string;
    telephonePortable: string;
}

